import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .make();

schema.prop('programmeAreaId').setType(Number);
schema.prop('projectId').setType(Number);

export default schema;
